import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class EmailForwardingService {
  constructor(private readonly http: HttpClient) {
  }

  getState(): Observable<{enabled: boolean}> {
    return this.http.get<{enabled: boolean}>(`${environment.apiUrl}/api/private/email-forwarding/state`);
  }

  setState(enable: boolean): Observable<void> {
    return this.http.put<void>(`${environment.apiUrl}/api/private/email-forwarding/state`, {enable});
  }
}
